
export interface IRawIssue {
	id: number;
	employeeAssets: string,
	businessApplicationsAssets: string,
	linkedServiceAssets: string,

	dataSetAssets: string,
	businessProcessesAssets: string,
};

export interface IIssue {
	id: number;
	employeeAssets: IIssueResourceData[],
	businessApplicationsAssets: IIssueResourceData[],
	linkedServiceAssets: IIssueResourceData[],

	businessProcessesAssets: IIssueResourceData[],
	dataSetAssets: IIssueResourceData[],
};

export interface IIssueResourceData {
	id: number,
	label: string
};

export function stringToIssue(rawString: string): IIssue
{
	var rawIssue = JSON.parse(rawString) as IRawIssue;

	let issue: IIssue = {
		id: rawIssue.id,
		businessApplicationsAssets: parseLinkedResources(rawIssue.businessApplicationsAssets),
		employeeAssets: parseLinkedResources(rawIssue.employeeAssets),
		linkedServiceAssets: parseLinkedResources(rawIssue.linkedServiceAssets),
		businessProcessesAssets: parseLinkedResources(rawIssue.businessProcessesAssets),
		dataSetAssets: parseLinkedResources(rawIssue.dataSetAssets),
	}

	return issue;
}

function parseLinkedResources(rawData: string): IIssueResourceData[] {
	return rawData?.split("*&*,")
		.filter(x => !!x)
		.map(asset => {
			var temp = asset.split(":");

			let result: IIssueResourceData = {
				id: stringToInt(temp[0].trim()),
				label: temp[1].trim(),
			};

			return result;
		}) ?? [];
}

function stringToInt(value: string) {
	var result = parseInt(value);
	if (isNaN(result)) {
		return undefined;
	}
	return result;
}